import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { AppMenuItem ,AppMenuSection} from '../../../../core/app-menu/app-menu';
@Injectable({ providedIn: 'root' })
export class MenuStateService {
  private menuItemsSubject = new BehaviorSubject<(AppMenuItem | AppMenuSection)[]>([]);
  menuItems$ = this.menuItemsSubject.asObservable();

  setMenuItems(items: (AppMenuItem | AppMenuSection)[]) {
    this.menuItemsSubject.next(items);
  }
}
